export default {
    letsGo: 'Fight, Guardian!',
    viewCourse: 'View Course',
    readMore: 'Read More'
}